import { render, staticRenderFns } from "./DocPage.vue?vue&type=template&id=0913bca6&"
import script from "./DocPage.vue?vue&type=script&lang=js&"
export * from "./DocPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports